import React from 'react';
import { CheckIcon } from '../../../components/common/Icons';

interface ServicesTabProps {
  services: string[];
}

const ServicesTab: React.FC<ServicesTabProps> = ({ services }) => {
  return (
    <section>
      <h2 className="h5 fw-bold text-dark mb-4">Services Offered</h2>
      <div className="row g-3">
        {services.map((service, index) => (
          <div key={index} className="col-12 col-sm-6 d-flex align-items-center">
            <CheckIcon className="text-primary me-2 flex-shrink-0" style={{ height: '1.25rem', width: '1.25rem' }} />
            <span className="text-muted">{service}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default ServicesTab;
